import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
          viewBox="0 0 14 14"
        >
          <g clip-path="url(#clip0)">
            <path
              fill="#FFF587"
              d="M11.94 11.96A6.989 6.989 0 0014 7c0-1.87-.739-3.638-2.06-4.96A6.959 6.959 0 006.982 0 6.95 6.95 0 002.04 2.06 6.92 6.92 0 000 7a6.92 6.92 0 002.04 4.94A6.95 6.95 0 006.983 14c1.87 0 3.634-.718 4.956-2.04zM5.391 7c0-.887.704-1.608 1.591-1.608S8.608 6.113 8.608 7c0 .887-.738 1.608-1.625 1.608S5.393 7.887 5.393 7z"
            ></path>
            <path
              fill="#B2DCFD"
              d="M8.608 7H14c0-1.87-.739-3.638-2.06-4.96-.01-.008.007.009-.001 0L8.125 5.854c.306.293.483.69.483 1.146z"
            ></path>
            <path
              fill="#A60F34"
              d="M5.392 7H0c0 1.858.734 3.62 2.04 4.939l3.814-3.814A1.65 1.65 0 015.392 7z"
            ></path>
            <path
              fill="#FDBF00"
              d="M6.983 14V8.605a1.634 1.634 0 01-1.13-.481L2.04 11.939c.008.008-.009-.008 0 0a7.066 7.066 0 004.943 2.06z"
            ></path>
            <path
              fill="#A24BDB"
              d="M5.854 5.875L2.04 2.06A7.001 7.001 0 000 7h5.392c0-.43.185-.836.462-1.125z"
            ></path>
            <path
              fill="#1FC974"
              d="M6.983 8.608c-.017 0 .017 0 0-.001V14c.017 0-.017 0 0 0a7.04 7.04 0 004.956-2.04L8.125 8.146a1.692 1.692 0 01-1.142.462z"
            ></path>
            <path
              fill="#39306B"
              d="M6.983 5.393V0A7.066 7.066 0 002.04 2.06c-.009.01.008-.007 0 .001l3.814 3.814a1.634 1.634 0 011.13-.482z"
            ></path>
            <path
              fill="#00D7DF"
              d="M8.125 8.146l3.814 3.814c.008-.008-.008.009 0 0A6.988 6.988 0 0014 7H8.608c0 .456-.177.853-.483 1.146z"
            ></path>
            <path
              fill="#3E99FC"
              d="M6.983 5.392c.43 0 .853.185 1.142.462L11.94 2.04A7.04 7.04 0 006.983 0c-.017 0 .017 0 0 0v5.393c.017 0-.017 0 0 0z"
            ></path>
            <path
              fill="#FFDA2D"
              d="M6.983 12.07V7l-3.577 3.572a5.09 5.09 0 003.577 1.497z"
            ></path>
            <path
              fill="#C567EA"
              d="M6.983 7L3.407 3.427A5.112 5.112 0 001.93 7h5.053z"
            ></path>
            <path
              fill="#D20041"
              d="M6.983 7H1.93c0 1.383.575 2.657 1.477 3.572L6.983 7z"
            ></path>
            <path
              fill="#5BE167"
              d="M6.983 7v4.622c.014.447-.019.448 0 .448a5.153 5.153 0 003.59-1.476L6.982 7z"
            ></path>
            <path
              fill="#54489B"
              d="M6.983 7V1.93a5.09 5.09 0 00-3.577 1.497L6.983 7z"
            ></path>
            <path
              fill="#66E7EC"
              d="M6.983 7l3.59 3.594A4.997 4.997 0 0012.07 7H6.983z"
            ></path>
            <path
              fill="#DAF2FE"
              d="M6.983 7h5.087a4.997 4.997 0 00-1.498-3.593L6.983 7z"
            ></path>
            <path
              fill="#65ADFD"
              d="M6.983 7l3.59-3.593a5.152 5.152 0 00-3.59-1.477c-.019 0 .02 0 0 0V7z"
            ></path>
            <path
              fill="#FFF587"
              d="M6.983 9.843V7L4.98 9c.509.516 1.224.835 2.003.843z"
            ></path>
            <path
              fill="#E681FA"
              d="M6.983 7L4.98 5a2.852 2.852 0 00-.824 2h2.827z"
            ></path>
            <path
              fill="#FF0059"
              d="M6.983 7H4.156c0 .776.318 1.486.824 2l2.003-2z"
            ></path>
            <path
              fill="#84E88D"
              d="M6.983 7v2.593c.008.25-.01.25 0 .25.776 0 1.502-.317 2.016-.823L6.983 7z"
            ></path>
            <path
              fill="#655AA5"
              d="M6.983 7V4.157A2.853 2.853 0 004.98 5l2.003 2z"
            ></path>
            <path
              fill="#99EFF2"
              d="M6.983 7l2.016 2.02A2.818 2.818 0 009.844 7H6.983z"
            ></path>
            <path
              fill="#E7FFFF"
              d="M6.983 7h2.86c0-.792-.32-1.504-.844-2.02L6.983 7z"
            ></path>
            <path
              fill="#8CC1FD"
              d="M6.983 7L9 4.98a2.893 2.893 0 00-2.016-.824c-.01 0 .01 0 0 0V7z"
            ></path>
            <circle cx="7" cy="7" r="3" fill="#fff"></circle>
          </g>
          <defs>
            <clipPath id="clip0">
              <path fill="#fff" d="M0 0H14V14H0z"></path>
            </clipPath>
          </defs>
        </svg>
      );
}